import { memo, useEffect, useState } from 'react';
import { Navigate, Outlet } from 'react-router';
import { Modal } from '@bonanza-social/navigation';
import { selectIsLogged } from '@bonanza-social/auth/state';
import { startListening, useSelector } from '@bonanza-social/toolkit/state';

import '@bonanza-social/auth';

function ProtectedRoutes() {
  const [loginModalClosed, setLoginModalClosed] = useState(false);
  const isLogged = useSelector(selectIsLogged);

  useEffect(() => {
    if (!isLogged) {
      Modal.open({
        namespace: 'auth',
        type: 'Auth',
        canClose: false,
        options: {
          hideHeader: true,
          onClosed: () => {
            setLoginModalClosed(true);
          },
        },
        style: {
          width: {
            mobile: '100%',
            tablet: '100%',
            desktop: 550,
          },
          height: {
            mobile: '100%',
            tablet: '100%',
            desktop: 800,
          },
          paddingTop: 'space-200',
          backgroundColor: 'screenBackground',
        },
      });

      return startListening({
        predicate: (_, currentState) => {
          return selectIsLogged(currentState);
        },
        effect: (_) => {
          Modal.close();
        },
      });
    }
  }, [isLogged]);

  if (!isLogged && loginModalClosed) {
    return <Navigate to="/" replace />;
  }

  if (!isLogged) {
    return null;
  }

  return <Outlet />;
}

export default memo(ProtectedRoutes);
